module.exports = __webpack_public_path__ + "img/11.9fb7eb03.jpg";